import React, { useState } from "react";
import ModalMessage from "./modal-message";
import { APP_ACTIONS } from "../constants/constant";

const ModalMessageFunction = (processAction) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState({});
  const [requestType, setRequestType] = useState("");

  const getModalData = (requestType,isDateExceed) => {
    setRequestType(requestType);
    if (requestType === APP_ACTIONS.APPROVE) {
      return {
        title: "processExtensionMessage",
         contentText: isDateExceed ? "dateExceeds" : "approveModalMessage",
        buttonText: "extendRequest",
      };
    } else if (requestType === APP_ACTIONS.SENDTOCCM) {
      return {
        title: "sendToCcm",
        contentText: "sendToCcmModalMessage",
        buttonText: "sendToCcm",
      };
    } else if (requestType === APP_ACTIONS.SENDTOBP) {
      return {
        title: "sendToBp",
        contentText: "sendToBpModalMessage",
        buttonText: "sendToBp",
      };
    } else if (requestType === APP_ACTIONS.REJECT) {
      return {
        title: "rejectRequest",
        contentText: "rejectModalMessage",
        buttonText: "rejectRequest",
      };
    } else if (requestType === APP_ACTIONS.DELETEPRODUCT) {
      return {
        title: "delete",
        contentText: "deleteProductMessage",
        buttonText: "delete",
      };
    } else if (requestType === APP_ACTIONS.DELETEDEALER) {
      return {
        title: "delete",
        contentText: "deleteDealerMessage",
        buttonText: "delete",
      };
    } else if (requestType === APP_ACTIONS.DELETEMACHINE) {
      return {
        title: "delete",
        contentText: "deleteMachineMessage",
        buttonText: "delete",
      };
    } else if (requestType === APP_ACTIONS.DELETEDIRECTDEBITDEALER) {
      return {
        title: "delete",
        contentText: "deleteDirectDebitDealerMessage",
        buttonText: "delete",
      };
    } else if (requestType === APP_ACTIONS.BOOKINTEREST) {
      return {
        title: "bookInterest",
        contentText: "bookInterestMessage",
        buttonText: "bookInterestButton",
      };
    } else if (requestType === APP_ACTIONS.CANCELLEDDEBITNOTE) {
      return {
        title: "cancelDbNote",
        contentText: "cancelDbNoteMessage",
        buttonText: "cancelDbNoteButton",
        buttonCancelText: "no"
      };
    }
  };

  const closeModal = (action) => {
    setIsModalOpen(false);
    processAction(action, requestType);
  };

  const getModal = (modalType,_,isDateExceed=false) => {
    setModalData(getModalData(modalType,isDateExceed));
    setIsModalOpen(true);
  };

  const modal = (
    <ModalMessage
      modalData={modalData}
      modalOpen={isModalOpen}
      closeModal={closeModal}
    />
  );

  return {
    getModal,
    modal,
  };
};

export default ModalMessageFunction;
